import React from 'react';
import { HamburgerIcon, CrossIcon, DashIcon, BreadcrumbChevronIcon } from '@mergermarket/acuris-react-icon';
import moment from 'moment';
import DisplayOnBreakpoint from '@mergermarket/acuris-react-display-on-breakpoint';

class Header extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-header"
    }, this.props.children);
  }

}

const HeaderTop = props => /*#__PURE__*/React.createElement("div", {
  className: "header-wrapper"
}, props.children);

const ActionList = props => /*#__PURE__*/React.createElement("ul", {
  className: "header-actions-list"
}, props.children);

const ActionItem = props => /*#__PURE__*/React.createElement("li", {
  className: `header-actions-list__item ${props.className ? props.className : ''}`,
  onClick: props.handleClick
}, props.children);

const NavigationMenuButton = props => {
  return /*#__PURE__*/React.createElement("button", {
    className: `header-nav__button ${props.displayCloseState ? 'header-nav__button--close' : ''}`,
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-nav__button-open"
  }, "Menu", /*#__PURE__*/React.createElement(HamburgerIcon, {
    title: "menu",
    className: "icon--small icon--menu header-nav__icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "header-nav__button-close"
  }, "Close", /*#__PURE__*/React.createElement(CrossIcon, {
    title: "close",
    className: "icon--small icon--cross header-nav__icon"
  })));
};

const NavigationMenu = ({
  navigationMenuExpanded,
  onMenuButtonClick,
  children
}) => navigationMenuExpanded === undefined || onMenuButtonClick === undefined ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NavigationMenuButton, {
  displayCloseState: navigationMenuExpanded,
  onClick: onMenuButtonClick
}), /*#__PURE__*/React.createElement("nav", {
  role: "navigation",
  className: "header-nav-menu"
}, children));

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navigationMenuExpanded: false
    };
    this.toggleNavigationMenuExpanded = this.toggleNavigationMenuExpanded.bind(this);
    this.passPropsIfChildIsMenu = this.passPropsIfChildIsMenu.bind(this);
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: `navigation-wrapper${this.state.navigationMenuExpanded ? ' navigation-menu--open' : ''}`
    }, React.Children.map(this.props.children, this.passPropsIfChildIsMenu));
  }

  passPropsIfChildIsMenu(child) {
    if (child.type !== NavigationMenu) return child;
    return React.cloneElement(child, {
      onMenuButtonClick: this.toggleNavigationMenuExpanded,
      navigationMenuExpanded: this.state.navigationMenuExpanded
    });
  }

  toggleNavigationMenuExpanded(e) {
    if (this.props.handleClick) {
      this.props.handleClick(e);
    }

    this.setState({
      navigationMenuExpanded: !this.state.navigationMenuExpanded
    });
  }

}

const NavigationBar = ({
  children
}) => /*#__PURE__*/React.createElement("nav", {
  role: "navigation",
  className: "header-nav"
}, children);

const NavigationList = props => {
  const customName = props.customName ? props.customName : '';
  return /*#__PURE__*/React.createElement("ul", {
    className: `nav-list ${navTypeClassName()} ${customName}`
  }, props.children);

  function navTypeClassName() {
    if (props.primary) {
      return `nav-list--primary`;
    } else if (props.secondary) {
      return `nav-list--secondary`;
    }

    return '';
  }
};

const NavigationItemContent = ({
  active,
  className,
  children,
  displayName,
  link,
  handleClick,
  newContent,
  newContentExpiryDate,
  betaContent
}) => {
  const navItemActive = active ? 'nav-list__item--active' : '';
  const newContentIsExpired = moment().isAfter(newContentExpiryDate, 'day');
  return /*#__PURE__*/React.createElement("li", {
    className: `nav-list__item ${navItemActive} ${className}`,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("a", {
    href: link
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-list__link-text"
  }, displayName), newContent && !newContentIsExpired && /*#__PURE__*/React.createElement(NewLabel, null), betaContent && /*#__PURE__*/React.createElement(BetaLabel, null)), children);
};

const NewLabel = () => /*#__PURE__*/React.createElement("span", {
  className: "nav-list__new-label",
  "data-navigation-item-new": true
}, "NEW");

const BetaLabel = () => /*#__PURE__*/React.createElement("span", {
  className: "nav-list__beta-label",
  "data-navigation-item-beta": true
}, "BETA");

const NavigationItem = props => props.hideOnSmallViewports === true ? /*#__PURE__*/React.createElement(DisplayOnBreakpoint, {
  greaterThan: "large-landscape"
}, /*#__PURE__*/React.createElement(NavigationItemContent, props)) : /*#__PURE__*/React.createElement(NavigationItemContent, props);

class NavigationItemGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isClosed: true
    };
    this.updateIsClosed = this.updateIsClosed.bind(this);
  }

  render() {
    const navItemIsClosed = this.state.isClosed ? '' : 'nav-list__item--open';
    return /*#__PURE__*/React.createElement("li", {
      className: `nav-list__item ${navItemIsClosed}`,
      onClick: this.updateIsClosed
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: this.props.handleClick
    }, this.props.displayName), /*#__PURE__*/React.createElement("button", {
      className: "nav-list__button"
    }, /*#__PURE__*/React.createElement("span", {
      className: "nav-list__button--open"
    }, /*#__PURE__*/React.createElement(DashIcon, {
      title: "Open Submenu",
      className: "icon--small header-nav__icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "visuallyhidden"
    }, "Open Menu")), /*#__PURE__*/React.createElement("span", {
      className: "nav-list__button--close"
    }, /*#__PURE__*/React.createElement(DashIcon, {
      className: "icon--small header-nav__icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "visuallyhidden"
    }, "Close Menu"))), this.props.children);
  }

  updateIsClosed() {
    this.setState({
      // @ts-ignore
      isClosed: !this.state.isClosed
    });
  }

}

const SecondaryNavigation = props => /*#__PURE__*/React.createElement("div", {
  className: "nav-list-wrapper nav-list-wrapper--secondary"
}, props.children);

const Breadcrumb = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb-wrapper"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "visuallyhidden"
  }, "You are currently here"), /*#__PURE__*/React.createElement("ol", {
    className: "nav-list nav-list--breadcrumb"
  }, React.Children.count(props.children) === 1 ? props.children : addChevronToChildren(props.children)));
}; // @ts-ignore


function addChevronToChildren(children) {
  return React.Children.map(children, (child, index) => index !== children.length - 1 ? React.cloneElement(child, child.props, /*#__PURE__*/React.createElement(BreadcrumbChevronIcon, {
    className: "icon--small"
  })) : child);
}

const HeaderLogo = props => {
  return /*#__PURE__*/React.createElement("h1", {
    className: "logo",
    onClick: props.handleClick
  }, /*#__PURE__*/React.createElement("a", {
    href: props.homeURL
  }, props.children));
};

export { ActionItem, ActionList, Breadcrumb, Header, HeaderLogo, HeaderTop, Navigation, NavigationBar, NavigationItem, NavigationItemGroup, NavigationList, NavigationMenu, NavigationMenuButton, SecondaryNavigation };
//# sourceMappingURL=index.js.map
